/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";

import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idRoletaCheckin: string;
  idCorretorSistemaOrigem: string;
  nomeCorretor?: string | null;
  nomeEquipe?: string | null;
  idImobiliaria?: string | null;
  nomeImobiliaria?: string | null;
}

export function useAdicionarManualmente() {
  const postData = async (props: Props) => {
    const ADICIONAR_MANUALMENTE = `${leadsWebEnviroment}/common/checkin/recepcao/adicionar-manualmente/v1`;
    const params = props.nomeCorretor && props.nomeEquipe ? {
      idRoletaCheckin: props.idRoletaCheckin,
      nomeCorretor: props.nomeCorretor,
      nomeEquipe: props.nomeEquipe,
      idImobiliaria: props.idImobiliaria,
      nomeImobiliaria: props.nomeImobiliaria,
    } : {
      idRoletaCheckin: props.idRoletaCheckin,
      idCorretorSistemaOrigem: props.idCorretorSistemaOrigem,
    };
    const response = await instance.post(ADICIONAR_MANUALMENTE, params);
    return response?.data?.data;
  };
  const mutation = useMutation({
    mutationFn: postData,
    onSuccess: () => { },
    onError: () => { },
  });

  return mutation;
}
